import React from "react";
import {Box, Grid, Typography} from "@mui/material";
import {ReactComponent as CalendarIcon} from "../../assets/calendar_icon.svg";
import {ReactComponent as ArrowDownIcon} from "../../assets/arrow_down_icon.svg";
import DatePicker from "react-datepicker";
import {Placement} from "popper.js";
// import {makeStyles} from "@material-ui/core";
import {makeStyles} from "@mui/styles";
// import {SystemCssProperties} from "@mui/system/styleFunctionSx/styleFunctionSx";

const useStyles = makeStyles(() => ({
    datePickerWrapper: {
        position: `relative`,
        display: `flex`,
        flexFlow: `row`,
        width: `100%`,
        // border: "1px solid #888888",
        // borderRadius: `5px`,
        backgroundColor: `#F1F1F1`,
        cursor: "pointer"
    },
    calendarIconBlock: {
        display: `flex`,
        alignItems: `center`,
        justifyContent: `center`,
    },
    calendarIconWrapper: {
        height: `44px`,
        width: `44px`,
        display: `flex`,
        alignItems: `center`,
        justifyContent: `center`,
    },
    dropdownIcon: {
        position: `absolute`,
        display: `flex`,
        right: `10px`,
        top: `45%`,
        zIndex: 2
    },
    datePickerBlock: {
        flex: `1 1 auto`,
        display: `flex`,
        flexFlow: `column`,
        height: `100%`
    },
    dateTimePicker: (props: any) => ({
        width: `100%`,
        border: "none",
        height: props.datePickerHeight,
        fontWeight: 500,
        paddingBottom: `5px`,
        backgroundColor: `#F1F1F1`,
        cursor: `pointer`,
        // '&:readonly': {
        //     backgroundColor: `inherit`
        // }
    }),
}))

interface DatePickerComponentDto {
    datePickerGridSide?: number;
    datePickerLabelValue?: string;
    datePickerValue: Date | null;
    datePickerRef: any;
    datePickerName: string;
    onChangeValue: (dateValue: Date, datePickerName: string) => void;
    maxDate?: Date | null;
    minDate?: Date | null;
    datePickerPlacement?: Placement;
}

export const DatePickerComponent: React.FC<DatePickerComponentDto> = ({
                                                                          datePickerGridSide,
                                                                          datePickerLabelValue,
                                                                          datePickerValue,
                                                                          datePickerRef,
                                                                          datePickerName,
                                                                          onChangeValue,
                                                                          maxDate,
                                                                          minDate,
                                                                          datePickerPlacement,
                                                                      }) => {
    const properties = {
        datePickerHeight: datePickerLabelValue ? `100%` : `44px`
    }
    const classes = useStyles(properties);

    const openDatePicker = (isOpen: boolean) => {
        if (datePickerRef && datePickerRef.current) {
            const refDatePicker = datePickerRef.current as any;
            refDatePicker.setOpen(isOpen);
        }
    }

    return (
        <Grid item {...(datePickerGridSide ? {xs: datePickerGridSide} : {xs: true})}>
            <Box
                className={classes.datePickerWrapper}
            >
                <Box
                    className={classes.calendarIconBlock}
                    onClick={() => {
                        openDatePicker(true);
                    }}
                >
                    <Box
                        className={classes.calendarIconWrapper}
                    >
                        <CalendarIcon/>
                    </Box>
                </Box>
                <Box
                    className={classes.dropdownIcon}
                    onClick={() => {
                        openDatePicker(true);
                    }}
                >
                    <ArrowDownIcon/>
                </Box>
                <Box
                    className={classes.datePickerBlock}
                >
                    {
                        datePickerLabelValue &&
                        <Box
                            onClick={() => {
                                openDatePicker(true);
                            }}
                        >
                            <Typography fontSize={`12px`} color={`#808080`} p={`0 2px`} lineHeight={2}>
                                {datePickerLabelValue}
                            </Typography>
                        </Box>
                    }
                    <Box sx={{
                        flex: `1 1 auto`
                    }}>
                        <DatePicker
                            name={`startDate`}
                            ref={datePickerRef}
                            dateFormat={`dd.MM.yyyy`}
                            popperProps={{
                                positionFixed: true, // use this to make the popper position: fixed
                                paddingBottom: `15px!important`
                            }}
                            // readOnly={true}
                            // open={isOpenStartDatePicker}
                            onChange={(date: Date) => {
                                onChangeValue(date, datePickerName);
                                // openDatePicker(false);
                                // setOpenStartDatePicker(false);
                            }}
                            onKeyDown={(e) => {
                                // e.preventDefault();
                            }}
                            className={classes.dateTimePicker}
                            selected={datePickerValue ? datePickerValue : null}
                            maxDate={maxDate ? maxDate : null}
                            popperPlacement={datePickerPlacement ? datePickerPlacement : "bottom"}
                            minDate={minDate ? minDate : null}
                        />
                    </Box>
                </Box>
            </Box>

        </Grid>

    )
}